import React from 'react';
import './SalesRanking.scss';
import defaultAvatar from '../../images/avatars/defaultSpaceman.png';

class SalesRanking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeFilter: 'ALL',
      streamerPage: 1,
      productPage: 1,
      pageSize: 10,
      streamerRankings: this.getMockStreamerRankings(),
      productRankings: this.getMockProductRankings(),
      filters:{
        startDate:'',
        endDate:'',
      },
    };
  }

  componentDidMount() {
    this.doSearch();
  }

  doSearch = () =>{
    const { token } = this.props.auth;
    const {timeFilter}=this.state;
    let dateBegin='';
    let dateEnd='';
    const now = new Date();
    if(timeFilter==='ALL'){
    }else if(timeFilter==='TODAY'){
      dateBegin=now;
      dateBegin.setHours(0, 0, 0, 0);
      dateBegin=dateBegin.toISOString().split('T')[0];
      dateEnd=now;
      dateEnd.setHours(0, 0, 0, 0);
      dateEnd=dateEnd.toISOString().split('T')[0];
    }else if(timeFilter==='THIS_MONTH'){
      dateBegin=new Date(now.getFullYear(),now.getMonth(),1);
      dateBegin.setHours(0, 0, 0, 0);
      dateBegin=dateBegin.toISOString().split('T')[0];
      dateEnd=new Date(now.getFullYear(),now.getMonth()+1,0);
      dateEnd.setHours(0, 0, 0, 0);
      dateEnd=dateEnd.toISOString().split('T')[0];
    }else if(timeFilter==='LAST_MONTH'){
      dateBegin=new Date(now.getFullYear(),now.getMonth()-1,1);
      dateBegin.setHours(0, 0, 0, 0);
      dateBegin=dateBegin.toISOString().split('T')[0];
      dateEnd=new Date(now.getFullYear(),now.getMonth(),0);
      dateEnd.setHours(0, 0, 0, 0);
      dateEnd=dateEnd.toISOString().split('T')[0];
    }else if(timeFilter==='THIS_YEAR'){
      dateBegin=new Date(now.getFullYear(),0,1);
      dateBegin.setHours(0, 0, 0, 0);
      dateBegin=dateBegin.toISOString().split('T')[0];
      dateEnd=new Date(now.getFullYear(),11,31);
      dateEnd.setHours(0, 0, 0, 0);
      dateEnd=dateEnd.toISOString().split('T')[0];
    }
    this.setState({filters:{startDate:dateBegin,endDate:dateEnd}},()=>{this.props.getSaleProductOrderRank(JSON.stringify(this.state.filters),token)});
  }

  getMockStreamerRankings = () => {
    const names = [
      'Super_Long_Professional_Gaming_Streamer_Username_That_Tests_Overflow_Behavior_With_Extra_Characters',
      'Extremely_Long_Twitch_Channel_Name_With_Many_Underscores_And_Numbers_12345_Testing_Text_Overflow',
      'Ultra_Mega_Professional_Esports_Player_With_Very_Long_Username_For_Testing_UI_Layout_Constraints',
      'GamingPro_YT', 'StreamKing_TTV', 'EpicGamer_YT', 'TechStreamer_TTV',
      'ProGamer_YT', 'LiveStream_TTV', 'GameMaster_YT', 'ConsoleGamer_TTV',
      'RPGFan_YT', 'BigStreamer_TTV', 'ActionGamer_YT', 'IndieGamer_TTV',
      'SpeedRunner_YT', 'CasualGamer_TTV', 'HardcoreGamer_YT', 'RetroGamer_TTV'
    ];

    return Array.from({ length: 100 }, (_, i) => ({
      rank: i + 1,
      name: names[i % names.length] + `_${Math.floor(i / names.length) + 1}`,
      avatar: i % 2 === 0 ? '/study-ark.jpg' : '/study-bellwright.jpg',
      totalSales: 1000000 - (i * 8500)
    }));
  }

  getMockProductRankings = () => {
    const products = [
      { title: 'The Ultimate Complete Edition Game of the Year Premium Deluxe Special Edition with All DLC Included and Bonus Content', id: 'P999' },
      { title: 'Super Ultra Mega Awesome Gaming Bundle Pack Collection Ultimate Edition Remastered Enhanced Director\'s Cut', id: 'P998' },
      { title: 'Legendary Exclusive Limited Time Offer Complete Package with Seasonal Pass and Cosmetic Items Bundle', id: 'P997' },
      { title: 'Ark: Survival Evolved - Steam Key', id: 'P001' },
      { title: 'Bellwright - Premium Edition', id: 'P002' },
      { title: 'Steam Gift Card $50', id: 'P003' },
      { title: 'Cyberpunk 2077 - Deluxe Edition', id: 'P007' },
      { title: 'Elden Ring - Standard Edition', id: 'P009' },
      { title: 'Red Dead Redemption 2', id: 'P011' },
      { title: 'The Witcher 3: Wild Hunt - GOTY', id: 'P006' },
      { title: 'PlayStation Plus - 12 Months', id: 'P005' }
    ];

    return Array.from({ length: 100 }, (_, i) => ({
      rank: i + 1,
      product: {
        id: products[i % products.length].id,
        title: products[i % products.length].title,
        image: i % 2 === 0 ? '/study-ark.jpg' : '/study-bellwright.jpg'
      },
      salesVolume: 5000 - (i * 45)
    }));
  }

  handleTimeFilterChange = (e) => {
    this.setState({
      timeFilter: e.target.value,
      streamerPage: 1,
      productPage: 1
    },()=>{this.doSearch()});
  }

  render() {
    const {
      timeFilter,
      streamerPage,
      productPage,
      pageSize,
      // streamerRankings,
      // productRankings
    } = this.state;
    const {admin:{saleProductOrder:{data:ranks}}} = this.props;

    const streamerStartIndex = (streamerPage - 1) * pageSize;
    const streamerEndIndex = streamerStartIndex + pageSize;
    const displayedStreamers = ranks?.user?.slice(streamerStartIndex, streamerEndIndex);
    const streamerTotalPages = Math.ceil((ranks?.user?.length||0) / pageSize);

    const productStartIndex = (productPage - 1) * pageSize;
    const productEndIndex = productStartIndex + pageSize;
    const displayedProducts = ranks?.product&&ranks?.product?.length>0?(ranks.product.slice(productStartIndex, productEndIndex)):[];
    const productTotalPages = Math.ceil((ranks?.product?.length||0) / pageSize);

    return (
      <div className="sales-ranking">
        <div className="page-header">
          <h2>Sales Ranking</h2>
          <p>Live Streamer Sales Ranking and Product Sales Ranking</p>
        </div>

        <div className="time-filter-bar">
          <select value={timeFilter} onChange={this.handleTimeFilterChange}>
            <option value="ALL">ALL</option>
            <option value="TODAY">TODAY</option>
            <option value="THIS_MONTH">THIS MONTH</option>
            <option value="LAST_MONTH">LAST MONTH</option>
            <option value="THIS_YEAR">THIS YEAR</option>
          </select>
        </div>

        <div className="ranking-panels">
          <div className="ranking-panel">
            <h3 className="panel-title">TOP 100 Live Streamer Sales Ranking</h3>

            <div className="ranking-table-wrapper">
              <table className="ranking-table">
                <tbody>
                  {displayedStreamers?.map((item,index) => (
                    <tr key={item.rank}>
                      <td className="rank-cell">
                        <span className={`rank-number ${index+1 <= 3 ? 'top-rank' : ''}`}>
                          {index+1}
                        </span>
                      </td>
                      <td className="streamer-cell">
                        <div className="streamer-info">
                          <img src={item?.user?.avatar||defaultAvatar} alt={item?.user?.name} className="streamer-avatar" />
                          <span className="streamer-name" title={item?.user?.name}>{item?.user?.name}</span>
                        </div>
                      </td>
                      <td className="sales-cell">
                        <div className="sales-amount">
                          <span className="amount-value">{item.total?.toLocaleString()}</span>
                          <span className="amount-unit">USDO</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {displayedStreamers&&displayedStreamers.length>0&&<div className="pagination">
              <div className="pagination-left">
                <span className="regular_title">
                  RECORDS: {ranks?.user?.length||0} (Page {streamerPage} of {streamerTotalPages})
                </span>
              </div>
              <div className="pagination-right">
                <button
                  className="regular"
                  onClick={() => this.setState({ streamerPage: streamerPage - 1 })}
                  disabled={streamerPage === 1}
                >
                  <i className="fa fa-arrow-left" />
                </button>
                <button
                  className="regular"
                  onClick={() => this.setState({ streamerPage: streamerPage + 1 })}
                  disabled={streamerPage >= streamerTotalPages}
                >
                  <i className="fa fa-arrow-right" />
                </button>
              </div>
            </div>}
          </div>

          <div className="ranking-panel">
            <h3 className="panel-title">TOP 100 Product Sales Ranking</h3>

            <div className="ranking-table-wrapper">
              <table className="ranking-table">
                <tbody>
                  {displayedProducts.map((item,index) => (
                    <tr key={item.rank}>
                      <td className="rank-cell">
                        <span className={`rank-number ${index+1 <= 3 ? 'top-rank' : ''}`}>
                          {index+1}
                        </span>
                      </td>
                      <td className="product-cell">
                        <div className="product-info">
                          <img src={item.product?.cover} alt={item.product?.name} className="product-thumbnail" />
                          <div className="product-details">
                            <div className="product-name" title={item.product?.name}>{item.product?.name}</div>
                            <div className="product-id">{item.product?.id}</div>
                          </div>
                        </div>
                      </td>
                      <td className="volume-cell">
                        <div className="sales-volume">
                          <span className="volume-number">{item.total?.toLocaleString()}</span>
                          <span className="volume-label">Sales Volume</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {displayedProducts&&displayedProducts.length>0&&<div className="pagination">
              <div className="pagination-left">
                <span className="regular_title">
                  RECORDS: {ranks?.product?.length||0} (Page {productPage} of {productTotalPages})
                </span>
              </div>
              <div className="pagination-right">
                <button
                  className="regular"
                  onClick={() => this.setState({ productPage: productPage - 1 })}
                  disabled={productPage === 1}
                >
                  <i className="fa fa-arrow-left" />
                </button>
                <button
                  className="regular"
                  onClick={() => this.setState({ productPage: productPage + 1 })}
                  disabled={productPage >= productTotalPages}
                >
                  <i className="fa fa-arrow-right" />
                </button>
              </div>
            </div>}
          </div>
        </div>
      </div>
    );
  }
}

export default SalesRanking;
